module.exports = __webpack_public_path__ + "icon_why-db0be80bbca7b64e760c7b9814878400.png";